import { PaymentAccount } from '../components/transaction/PaymentAccount';
import type { Account, AccountType } from '../generated-types';

export const accountBlacklist: AccountType[] = ['LOAN'];
type OptionalAccount = Account | undefined;

const isBlacklisted = (account: Account): boolean => accountBlacklist.includes(account.type);
export const isNotBlacklisted = (account: Account): boolean => !isBlacklisted(account);

export const isValidAccountTransferFrom = (account: OptionalAccount): boolean =>
    !!account && isNotBlacklisted(account) && account.type !== 'BSU' && account.rights.transferFrom;

export const isValidAccountTransferTo = (account: OptionalAccount): boolean =>
    !!account && isNotBlacklisted(account) && account.rights.transferTo;

export const isValidAccountPaymentFrom = (account: OptionalAccount): boolean =>
    !!account && isNotBlacklisted(account) && account.type !== 'BSU' && account.rights.paymentFrom;

export const isNotBSU = (account: OptionalAccount): boolean =>
    !!account && isNotBlacklisted(account) && account.type !== 'BSU';

export const isValidAvtalegiroFromAccount = (account: OptionalAccount) =>
    isValidAccountPaymentFrom(account) && account!.rights.avtalegiroFrom !== false;

export const isValidPaymentAgreementAccount = (account: OptionalAccount) =>
    isValidAccountPaymentFrom(account) && account!.rights.paymentAgreementFrom !== false;

export const isValidTransferAgreementAccount = (account: OptionalAccount) =>
    isValidAccountTransferFrom(account) && account!.rights.paymentAgreementFrom !== false;

export const isOwnAccount = (account: OptionalAccount): boolean =>
    account !== undefined && account.owners.some((owner) => owner.primaryOwner && owner.equalToUserLoggedOn);

export const getPaymentAccount = (
    accounts: OptionalAccount[],
    accountCheck: (account: OptionalAccount) => boolean = isValidAccountPaymentFrom,
): PaymentAccount | undefined => {
    if (!accounts) return undefined;
    return accounts.find(accountCheck);
};

export const isLoanAccount = (account: Account): boolean => account.type === 'LOAN';
export const isFlexiLoanAccount = (account: Account): boolean => account.type === 'FLEXILOAN';
export const isLoanOrFlexiAccount = (account: Account): boolean =>
    account.type === 'LOAN' || account.type === 'FLEXILOAN';
export const isNotLoanAccount = (account: Account): boolean => account.type !== 'LOAN';
